var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stats-preview-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.stats.completions)+" completions, ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.stats.inProgress)+" in progress.")])])}
var staticRenderFns = []

export { render, staticRenderFns }